import { Component } from '@angular/core';
import { AuthenticationService } from '../../views/authentication/authentication.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent {
  constructor(public service: AuthenticationService) {

  }
 }



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar/app-sidebar.component.ts